<script setup lang="ts">
import SubmitButtonContent from '@/components/devextreme/SubmitButtonContent.vue';
import Icons from '@/constants/Icons';
import { DxButton } from 'devextreme-vue/button';
import { DxTextBox } from 'devextreme-vue/text-box';
import { ref } from 'vue';
import BootstrapAlert from '@/components/bootstrap/BootstrapAlert.vue';
import BootstrapCard from '@/components/bootstrap/BootstrapCard.vue';
import { useAccountService } from '@/services/api/accountService';
import Routes from '@/constants/Routes';
import { useRouter } from 'vue-router';

definePage({ name: 'AccountMfaRemove', meta: { title: 'account.removeAppTitle' } });

const loading = ref<boolean>(false);
const currentPassword = ref('');
const account = useAccountService();
const router = useRouter();

async function removeMfa(): Promise<void> {
  loading.value = true;
  const success = await account.removeMfa(currentPassword.value);
  if (!success) {
    loading.value = false;
  } else {
    await router.push({ name: Routes.Account.Mfa });
  }
}
</script>

<template>
  <BootstrapCard :header-text="$t('account.removeAppTitle')">
    <BootstrapAlert :type="'warning'">
      <p>{{ $t('account.removeAppFallback') }}</p>
      <i18n-t keypath="account.removeAppRecommendation" tag="p" class="mb-0" scope="global">
        <template #app><strong>{{ $t('account.removeAppReEnable') }}</strong></template>
      </i18n-t>
    </BootstrapAlert>

    <form @submit.prevent="removeMfa">
      <DxTextBox v-model:value="currentPassword" mode="password" :label="$t('labels.currentPassword')" label-mode="floating"
          :disabled="loading" class="mt-3" />
      <DxButton type="danger" :use-submit-behavior="true" :disabled="loading || !currentPassword" class="mt-3">
        <SubmitButtonContent :loading="loading" :text="$t('account.removeAppButton')" :icon="Icons.Xmark" />
      </DxButton>
    </form>
  </BootstrapCard>
</template>

<style scoped>

</style>